var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-progress',{attrs:{"percentage":50,"show-text":false,"color":"#fff100","define-back-color":"rgb(35, 24, 21)","stroke-width":3}})}
var staticRenderFns = []

export { render, staticRenderFns }